import { Theme } from '@mui/material';
/**
 * @example styles for pop over component
 */
const ccfPopOverStyles = (theme: Theme) => {
  const styles = {
    popOverMain: {
      display: 'flex',
      flexDirection: 'column',
      height: 'auto',
      minWidth: '160px',
      justifyContent: 'space-evenly',
      alignContent: 'center',
      alignItems: 'center',
      background: `${theme?.palette?.background?.paper} 0% 0% no-repeat padding-box`,
      boxShadow: '0px 1px 2px #00000029',
      borderRadius: '4px',
      opacity: '1',
      padding: '0',
    },
    popOverOptions: {
      width: '100%',
      padding: '5px 10px',
      minHeight: 'auto',
      cursor: 'pointer',
      color: theme?.palette?.text?.primary,
      '&:hover': {
        backgroundColor: '#ecf5fa',
        fontWeight: '600',
      },
    },
    popOverOverflow: {
      fill: theme?.palette?.secondary?.main,
      cursor: 'pointer',
    },
  };
  return styles;
};

export default ccfPopOverStyles;
